function bidIdResolver(BXDataService, $transition$) {
    return $transition$.params().bidId;
}
function bidResolver(BXDataService, BXReferenceService, $transition$) {


    let bidId = $transition$.params().bidId;

    return BXDataService.getBid(bidId);
}
bidResolver.$inject = ['BXDataService', 'BXReferenceService', '$transition$'];
bidIdResolver.$inject = ['BXDataService', '$transition$'];


const servicePaymentBill = {
    name: 'desktop.paymentbill',
    url: "services-payment/{bidId}/bill/",
    component: "paymentBill",

    resolve: {

        bidId:bidIdResolver,
        bid: bidResolver

    },

    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./services-payment.module")
        .then(mod => $ocLazyLoad.load(mod.SERVICE_PAYMENT_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    }



};

const servicePaymentInvoice = {
    name: 'desktop.paymentinvoice',
    url: 'services-payment/{bidId}/invoice/',
    component: 'paymentInvoice',

    resolve: {
        bidId:bidIdResolver,
     //   bid: bidResolver

    },

    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  

      return import(/*webpackChunkName: "desktop.module" */ "./services-payment.module")
        .then(mod => $ocLazyLoad.load(mod.SERVICE_PAYMENT_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    }



  };



  const servicePaymentReceiptIndex = {
    name: 'desktop.paymentreceipt',
    url: 'services-payment/{bidId}/receipt/',
    component: 'paymentReceipt',

    resolve: {
        bidId:bidIdResolver,
     //   bid: bidResolver

    },

    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  

      return import(/*webpackChunkName: "desktop.module" */ "./services-payment.module")
        .then(mod => $ocLazyLoad.load(mod.SERVICE_PAYMENT_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    }



  };



const servicePaymentDocs = {
    name: 'desktop.paymentdocs',
    url: 'services-payment/{bidId}/docs/',
    component: 'paymentDocs',

    resolve: {
        bidId:bidIdResolver,
        bid: bidResolver

    },

    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./services-payment.module")
        .then(mod => $ocLazyLoad.load(mod.SERVICE_PAYMENT_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    }



  };

  
const servicePaymentOnline = {
    name: 'desktop.paymentonline',
    url: 'services-payment/{bidId}/online/',
    component: 'paymentOnline',
    resolve: {
        bidId:bidIdResolver,
        bid: bidResolver

    },

    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./services-payment.module")
    
        .then(mod => $ocLazyLoad.load(mod.SERVICE_PAYMENT_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    }



  };

  
const servicePaymentReceipt = {
    name: 'desktop.paymentreceipts',
    url: 'services-payment/{bidId}/receipts/',
    component: 'paymentReceipts',
    resolve: {
        bidId:bidIdResolver,
        bid: bidResolver

    },

    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
  
      return import(/* webpackChunkName: "desktop.module" */ "./services-payment.module")
        .then(mod => $ocLazyLoad.load(mod.SERVICE_PAYMENT_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    }



  };


export {

    servicePaymentBill,
    servicePaymentInvoice,
    servicePaymentReceipt,
    servicePaymentDocs,
    servicePaymentOnline,
    servicePaymentReceiptIndex
  

    
};






// WEBPACK FOOTER //
// ./src/components/desktop/services-payment/service-payment.module.states.js